import { useHistory } from "react-router-dom";
import { triggerAlert } from "redux/reducers/appSlice";
import { logOut } from "redux/reducers/authSlice";
import { useAppDispatch } from "redux/store/hooks";
import { removeAllFromLocalStorage } from "utils/storage/Local";
import { removeAllFromSessionStorage } from "utils/storage/Session";
import { translateFrontEndAlerts } from "utils/translation";
import RoutePaths from "routes/RoutePaths";
import { googleLogout } from '@react-oauth/google';

const useAuth = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const logoutUser = () => {
    dispatch(
      triggerAlert({
        type: "info",
        children: translateFrontEndAlerts(21001),
      })
    );
    setTimeout(() => {
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(21002),
        })
      );
      setTimeout(() => {
        removeAllFromLocalStorage();
        removeAllFromSessionStorage();
        dispatch(logOut());
        googleLogout();
        history.push(RoutePaths.root);
        history.go(0);
      }, 1000);
    }, 1000);
  };

  return {
    logoutUser,
  };
};

export default useAuth;
